import React, { Component } from "react";
import { connect } from "react-redux";
import {
    addQuestionToDeck,
    createDeck,
    fetchAvailableQuestions,
    updateHeaderInfo,
    getAllQuestions,
    getQuestionResults,
    editDeck,
    getUserDetails,
    trackPage
} from "../actions";
import { EditDeckForm, ChooseQuestionsForm, LoadingCard } from "../components";
import { withRouter } from 'react-router-dom';
import { deviceData, setActiveNavigationWidget } from "../common";

//make state = initial_state
class EditDeckScreen extends Component {
    state = {
        creationStage: 0,
        deckName: "",
        deckSummary: "",
        areas: "",
        years: "",
        questions: "",
        quetionArr: [],
        keywords: [],
        yearObj: [],
        areaObj: [],
        questionObj: [],
        keywordsObj: [],
        ready: false,
        openBook: false,
        isHome: false,
        isPublic: false,
        isSpaced: false,
        flashCards: false,
        questionCount: 0,
        tracking: null
    };

    componentDidMount = async () => {
        setActiveNavigationWidget("myDecksFooterIcon");

        let newYearObj = [];
        let newAreaObj = [];
        let newKeywordsObj = [];
        this.props.user_details.SASPYears.map(year => {
            if (year.useravailable == 1) {
                newYearObj = { ...newYearObj, [year.ProductYear]: false };
            }
        });

        this.props.user_details.availableAreas.map(area => {
            newAreaObj = { ...newAreaObj, [area.QArea]: false };
        });

        this.props.user_details.availableKeywords.map(keyword => {
            newKeywordsObj = { ...newKeywordsObj, [keyword.keyword]: false };
        });

        this.setState({
            ...this.state,
            yearObj: newYearObj,
            areaObj: newAreaObj,
            keywordsObj: newKeywordsObj,
            tracking: deviceData(this.props.location, 'navigate') 
        });

        const { mcid, key } = this.props.auth_feedback;
        
        // this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'));

        let tracking = deviceData(this.props.location, 'navigate');

        let tobj = {
            mcid: mcid,
            key: key,
            tracking: tracking
        }

        await this.props.trackPage(tobj);

        let obj = {
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            gamemode: this.props.location.gameMode,
            deckID: this.props.location.deckID,
            generalOnly: 1
        };

        await this.props.getQuestionResults(obj);

        // return this.props.updateHeaderInfo({route:"/editDeckScreen"});
        return this.props.updateHeaderInfo({route:"/editDeckScreen", iconOne: 'home'});
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.get_question_results !== this.props.get_question_results) {

            let tQuestion = this.props.deckList.find(item => item.deckID === this.props.location.deckID);

            if (Array.isArray(tQuestion)) {
                tQuestion = tQuestion[0];
            }

            let newQuestionObj = [];
            let res = this.props.get_question_results.questions;
            if (res.length) {
                newQuestionObj = {};
                for (const i in res) {
                    newQuestionObj[res[i].QuestionID] = (res[i].isActiveQuestion == "1" ? true : false);
                }
            }
            
            return this.setState({
                ...this.state,
                deckName: tQuestion.deckname,
                deckSummary: (typeof tQuestion.DeckSummary === 'undefined' ? '' : tQuestion.DeckSummary),
                isHome: (Number(tQuestion.isHome) === 1 ? true : false),
                isPublic: (Number(tQuestion.isPublic) === 1 ? true : false),
                isSpaced: (Number(tQuestion.isspaced === 1) ? true : false),
                flashCards: (Number(tQuestion.flashCards === 1) ? true : false),
                openBook: (Number(tQuestion.gameMode) === 3 ? true : false),
                questionCount: res.filter(item => Number(item.isActiveQuestion) === 1).length,
                questionArr: res,
                questionObj: newQuestionObj,
                ready: true
            });
        }
    };

    render() {
        const INITIAL_STATE = {
            creationStage: 0,
            keywords: "",
            deckName: "",
            deckSummary: "",
            areas: "",
            years: "",
            yearObj: [],
            areaObj: [],
            keywordsObj: [],
            questionObj: [],
            ready: false,
        };

        const nextStage = () => {
            this.setState({
                ...this.state,
                creationStage: this.state.creationStage + 1
            });
        };

        const setProp = async (key, value) => {
            if (key == 'questionObj') {
                let temp = 0;
                for (let [tkey, tval] of Object.entries(value)) {
                    if (tval) { temp++; }
                }
                this.setState({
                    ...this.state,
                    [key]: value,
                    questionCount: temp
                });
            } else {
                this.setState({
                    ...this.state,
                    [key]: value
                });
            }

            let obj = {
                mcid: this.props.user_details.mcid,
                key: this.props.user_details.key,
                deckID: this.props.location.deckID
            }

            obj[key] = value ? 1 : 0;

            await this.props.editDeck(obj);
        }

        const getQuestionCount = async (obj) => {
            obj.myYears = makeList(obj.myYears);
            obj.myAreas = makeList(obj.myAreas);
            await this.props.getAllQuestions(obj);
            this.setState({
                ...this.state,
                questionCount: this.props.get_question_count.questionCount
            });

            return this.props.get_question_count.questionCount;
        }

        const getQuestionResults = async (obj) => {
            obj.generalOnly = 1;
            this.props.getQuestionResults(obj);
        }

        const sendQuestions = (years, areas, keywords, name, summary = '') => {
            let actualYears = "";
            let actualAreas = "";
            let actualKeywords = "";
            Object.keys(years).forEach((year, index) => {
                if (years[year] === true) {
                    if (index === Object.keys(years).length - 1) {
                        actualYears +=year.toString();
                    } else {
                        actualYears +=year.toString() + ",";
                    }
                }
            });
            
            Object.keys(areas).forEach((area, index) => {
                if (areas[area] === true) {
                    if (index === Object.keys(areas).length - 1) {
                        actualAreas += area.toString();
                    } else {
                        actualAreas += area.toString() + ",";
                    }
                }
            });

            Object.keys(keywords).forEach((keyword, index) => {
                if (keywords[keyword] === true) {
                    if (index === Object.keys(keywords).length - 1) {
                        actualKeywords +=keyword.toString();
                    } else {
                        actualKeywords +=keyword.toString() + ",";
                    }
                }
            });

            this.setState({
                ...this.state,
                years: actualYears,
                areas: actualAreas,
                keywords: actualKeywords,
                deckName: name,
                deckSummary: summary,
                creationStage: 1,
            });
        };

        const goBack = async () => {
            document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
            this.props.history.push('/myDecks');
        };

        const goHome = async () => {
            document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
            this.props.history.push('/home');
        }

        const createDeck = async questions => {
            
            let createDeckData = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                deckName: this.state.deckName,
                deckPriority: 999,
                deckSummary: this.state.deckSummary,
                isHome: this.state.isHome,
                isSpaced: this.state.isSpaced,
                ispublic: this.state.isPublic,
                gameMode: this.state.openBook === true ? 3 : 4,
                tracking: this.state.tracking
            };

            createDeckData.tracking.action = 'updated deck';

            const addQuestions = async questions => {
                let actualQuestions = "";
                Object.keys(questions).forEach((question, index) => {
                    if (questions[question] === true) {
                        if (index === Object.keys(questions).length - 1) {
                            actualQuestions += question.toString();
                        } else {
                            actualQuestions += question.toString() + ",";
                        }
                    } else {
                        if (index === Object.keys(questions).length - 1) {
                            actualQuestions += question.toString();
                        } else {
                            actualQuestions += question.toString() + ",";
                        }
                    }
                });

                this.setState({
                    questions: actualQuestions
                });
            };
            await this.props.createDeck(createDeckData);
            return addQuestions(questions);
        };

        const makeList = (arrs) => {
            let r = '';
            let c = 0;
            for (const index in arrs) {
                if (arrs[index]) {
                    if (c > 0) {
                        r += ',';
                    }

                    r += index;
                    c++;
                }
            }
            return r;
        }

        const gapFunc = async (data) => {
            if (!data.name) { return false; } 
            let deckData = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                gamemode: data.openBook === true ? 3 : 4,
                isSpaced: (data.isSpaced ? 1 : 0),
                isPublic: (data.isPublic ? 1 : 0),
                isHome: (data.isHome ? 1 : 0),
                deckID: this.props.location.deckID,
                deckName: data.name,
                decksummary: data.summary,
                deckPriority: (data.priority ? data.priority : 999),
                isActive: (data.isActive ? 1 : 0),
                tracking: this.state.tracking,
                flashCards: (data.flashCards ? 1 : 0),
            };

            deckData.tracking.action = 'updated deck';

            

            // await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
            await  this.props.editDeck(deckData);
            goBack();
        }

        const getAreaText = () => {
            let str = "";
            
            let arr = this.props.get_question_results.areavar.split(',');

            let cnt = 0;
            for (let i of arr) {
                let t = this.props.user_details.availableAreas.find(item => item.QArea === i);

                if (typeof t !== 'undefined') {
                    if (cnt) { str += ', '; } 
                    str += t.AreaDescription + " (" + i + ')';
                    cnt++;
                }
                
            }

            if (str === '') { str = "None"; }
            return str;
        }

        const getYearText = () => {
            let str = this.props.get_question_results.yearvar;
            let arr = str.split(',');

            if (Number(arr[0]) < Number(arr[arr.length - 1])) {
                let t = arr.reverse();
                str = "";
                let cnt = 0;
                
                for (let i of t) {
                    if (cnt > 0) { str += ', '; } else {  cnt++; }
                    str += i.trim();
                }
            } else {
                str = 'None'
            }

            return str;
        }

        const resetForm = () => {
            this.setState({
                INITIAL_STATE
            });
        };

        const returnFormStage = () => {
            switch (this.state.creationStage) {
                case 1:
                    return (
                        <ChooseQuestionsForm
                            questionCount={this.props.available_questions.questionCount}
                            questions={this.props.available_questions.question}
                            questionObj={this.state.questionObj}
                            goBack={goBack}
                            goHome={goHome}
                            nextStage={nextStage}
                            resetForm={resetForm}
                            createDeck={createDeck}
                        />
                    );

                default:
                    //TODO refactor to prevent unnecessary rerenders
                    if (this.state.ready) {
                        return (
                            <>
                                <EditDeckForm
                                    keywords={this.state.keywordsObj}
                                    name={this.state.deckName}
                                    summary={this.state.deckSummary}
                                    authorizedyears={this.props.user_details.authorizedyears}
                                    SASPYears={this.props.user_details.SASPYears}
                                    yearsObj={this.state.yearObj}
                                    areaObj={this.state.areaObj}
                                    availableAreas={this.props.user_details.availableAreas}
                                    goBack={goBack}
                                    goHome={goHome}
                                    sendQuestions={sendQuestions}
                                    resetForm={resetForm}
                                    createDeck={createDeck}
                                    getQuestionCount={getQuestionCount}
                                    getQuestionResults={getQuestionResults}
                                    user_details={this.props.user_details}
                                    gapFunc={gapFunc}
                                    questionCount={this.state.questionCount}
                                    questions={this.props.available_questions.question}
                                    questionArr={this.state.questionArr}
                                    questionObj={this.state.questionObj}
                                    deckList={this.props.deckList}
                                    results={this.props.get_question_results}
                                    openBook={this.state.openBook}
                                    isHome={this.state.isHome}
                                    isPublic={this.state.isPublic}
                                    isSpaced={this.state.isSpaced}
                                    flashCards={this.state.flashCards}
                                    setProps={setProp}
                                    deckID={this.props.location.deckID}
                                    addQuestionToDeck={this.props.addQuestionToDeck}
                                    auth_feedback={this.props.auth_feedback}
                                    yearText={getYearText}
                                    areaText={getAreaText}
                                    editDeck={this.props.editDeck}
                                    icons={this.props.helperIcons}
                                />
                            </>
                        );
                    } else {
                        //TODO add skeleton loader
                        return <LoadingCard />;
                    }
            }
        };

        return returnFormStage();
    }
}

const mapStateToProps = state => {
    const { user_details, auth_feedback } = state.auth;
    const { newDeckInfo, deckList } = state.decks;
    const { available_questions, get_question_count, question, get_question_results } = state.question;
    const { helperIcons } = state.device;
    return { 
        user_details, 
        auth_feedback, 
        available_questions, 
        newDeckInfo, 
        get_question_count,
        question, 
        deckList,
        get_question_results,
        helperIcons
    };
};

export default connect(mapStateToProps, {
    fetchAvailableQuestions,
    createDeck,
    addQuestionToDeck,
    updateHeaderInfo,
    getAllQuestions,
    getQuestionResults,
    editDeck,
    getUserDetails,
    trackPage
})(withRouter(EditDeckScreen));
